import Cookies from 'js-cookie'

function currentLangType() {
  const cookieLang = Cookies.get('lang')
  if (cookieLang) return cookieLang
  const browserLanguage = (
    navigator.language || navigator.browserLanguage
  ).toLowerCase()
  const langTypeKeyList = ['zh', 'en']
  for (const lang of langTypeKeyList) {
    if (browserLanguage.indexOf(lang) > -1) {
      return lang
    }
  }
  return 'zh'
}

export default currentLangType
